import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseModule from '@/store/baseModule';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import BaseService from '@/services/services/tools/baseService';

export default (store) => {
  store.registerModule(
    ['actionplans', 'authors'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/authors/actionplans`,
        }),
        treatListResponse: (response) => {
          const array = response.data.items;
          return array.filter(
            (el, index) => index === array.findIndex((x) => x.id === el.id)
          );
        },
      }),
      makeQueryParams: makeListRequest({
        useEntities: true,
        limitItemsRequest: 500,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'actionplans/authors',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.loadItemsOnCurrentEntityChange();
  });
};
